/**
 * Theme store - flips `data-theme` on <html>. Persists to localStorage so
 * the user's choice survives a refresh.
 */
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type Theme = 'light' | 'dark';

type State = {
  theme: Theme;
  setTheme: (t: Theme) => void;
  toggle: () => void;
};

function applyTheme(t: Theme) {
  if (typeof document !== 'undefined') {
    document.documentElement.setAttribute('data-theme', t);
  }
}

export const useTheme = create<State>()(
  persist(
    (set, get) => ({
      theme: 'dark',
      setTheme: (t) => {
        applyTheme(t);
        set({ theme: t });
      },
      toggle: () => {
        const next: Theme = get().theme === 'light' ? 'dark' : 'light';
        applyTheme(next);
        set({ theme: next });
      },
    }),
    {
      name: 'orthodox-way:theme',
      onRehydrateStorage: () => (s) => {
        if (s) applyTheme(s.theme);
        else applyTheme('dark');
      },
    },
  ),
);
